import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Radio, Alert, TreeSelect } from 'antd';

const formItemLayout = {
  labelCol: {
    sm: { span: 6 },
  },
  wrapperCol: {
    sm: { span: 18 },
  },
};

const FormItem = Form.Item;

function UpdateForm({
  form,
  orgTreeNodes,
  item: {
    name,
    organization,
    first_list_url: firstListUrl,
    second_list_url: secondListUrl,
    data_type: dataType,
    first_title: firstTitle,
    first_detail_url: firstDetailUrl,
  },
}) {
  const { getFieldDecorator } = form;
  return (
    <Form>
      <div style={{ marginBottom: 10 }}>
        <Alert
          type="warning"
          message={
            <div style={{ fontSize: 12 }}>
              提示：采集器会基于起始文章标题与URL定位页面元素，
              并智能识别类似元素作为采集对象。
              <a href="/assets/images/spider-sample.jpg" target="_blank">
                查看示例
              </a>
            </div>
          }
        />
      </div>
      <FormItem label="组织机构" {...formItemLayout}>
        {getFieldDecorator('organization', {
          rules: [{ required: true, message: '请输入机构名称' }],
          initialValue: organization,
        })(
          <TreeSelect
            showSearch
            style={{ width: '100%' }}
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            placeholder="请选择"
            allowClear
            treeDefaultExpandAll
          >
            {orgTreeNodes}
          </TreeSelect>,
        )}
      </FormItem>
      <FormItem label="任务名称" {...formItemLayout}>
        {getFieldDecorator('name', {
          rules: [{ required: true, message: '请填写任务名称' }],
          initialValue: name,
        })(<Input placeholder="请填写任务名称" />)}
      </FormItem>
      <FormItem label="源列表第一页URL" {...formItemLayout}>
        {getFieldDecorator('first_list_url', {
          rules: [
            {
              required: true,
              message: '请填写源列表第一页URL',
            },
            {
              pattern: /^((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-.,@?^=%&:\/~+#]*[\w\-@?^=%&\/~+#])?$/,
              message: '请填写正确格式的URL地址',
            },
          ],
          initialValue: firstListUrl,
        })(<Input placeholder="如：https://www.example.com" />)}
      </FormItem>
      <FormItem label="源列表第二页URL" {...formItemLayout}>
        {getFieldDecorator('second_list_url', {
          initialValue: secondListUrl,
          rules: [
            {
              pattern: /^((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-.,@?^=%&:\/~+#]*[\w\-@?^=%&\/~+#])?$/,
              message: '请填写正确格式的URL地址',
            },
          ],
        })(<Input placeholder="选填" />)}
      </FormItem>
      <FormItem label="数据格式" {...formItemLayout}>
        {getFieldDecorator('data_type', {
          rules: [{ required: true, message: '请选择数据格式' }],
          initialValue: dataType || 'html',
        })(
          <Radio.Group>
            <Radio value="html">HTML</Radio>
            <Radio value="json">JSON</Radio>
          </Radio.Group>,
        )}
      </FormItem>
      <FormItem label="起始文章标题" {...formItemLayout}>
        {getFieldDecorator('first_title', {
          rules: [{ required: true, message: '请填写起始文章标题' }],
          initialValue: firstTitle,
        })(<Input placeholder="请填写起始文章标题" />)}
      </FormItem>
      <FormItem label="起始文章URL" {...formItemLayout}>
        {getFieldDecorator('first_detail_url', {
          rules: [{ required: true, message: '请填写起始文章URL' }],
          initialValue: firstDetailUrl,
        })(<Input placeholder="请填写起始文章URL" />)}
      </FormItem>
      {/* 尚未完成
      <div style={{ textAlign: 'right' }}>
        <a
          target="_blank"
          href={window.G.pyspiderUrl}
          style={{ textDecoration: 'underline' }}
        >
          访问高级模式
        </a>
      </div>
      */}
    </Form>
  );
}

UpdateForm.propTypes = {
  form: PropTypes.shape().isRequired,
  item: PropTypes.shape().isRequired,
  orgTreeNodes: PropTypes.arrayOf(PropTypes.element).isRequired,
};

export default Form.create()(UpdateForm);
